<template>
  <div>
    <div class="goal-detail">
      <div class="name">姓名：{{ employeeName || '' }}</div>
      <div v-if="yearTableData.length > 0" class="item">
        <div class="item-title">每年</div>
        <el-table :data="yearTableData" border stripe>
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="yearName" label="年份" min-width="80"></el-table-column>
          <el-table-column
            v-for="item in yearColumns"
            :key="item.id"
            :label="item.starName"
            :prop="'yearTargetNum' + item.saleStar"
            min-width="150"
          ></el-table-column>
          <el-table-column label="目标数量" min-width="150">
            <template #default="{ row }">
              <div v-if="!row.hasExpired" class="btn">
                <el-link type="primary" style="margin-right: 20px;" @click="showOrHideEditGoalModalHandle('year', row)">编辑</el-link>
                <el-link type="danger" @click="deleteHandle('year', row)">删除</el-link>
              </div>
              <span v-else>(已过去的日期不允许操作)</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="quarterTableData.length > 0" class="item">
        <div class="item-title">每季度</div>
        <el-table :data="quarterTableData" border stripe>
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="quarterName" label="季度" min-width="80"></el-table-column>
          <el-table-column
            v-for="item in quarterColumns"
            :key="item.id"
            :label="item.starName"
            :prop="'quarterTargetNum' + item.saleStar"
            min-width="150"
          ></el-table-column>
          <el-table-column label="目标数量" min-width="150">
            <template #default="{ row }">
              <div v-if="!row.hasExpired" class="btn">
                <el-link type="primary" style="margin-right: 20px;" @click="showOrHideEditGoalModalHandle('quarter', row)">编辑</el-link>
                <el-link type="danger" @click="deleteHandle('quarter', row)">删除</el-link>
              </div>
              <span v-else>(已过去的日期不允许操作)</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="monthTableData.length > 0" class="item">
        <div class="item-title">每月</div>
        <el-table :data="monthTableData" border stripe>
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="monthName" label="月份" min-width="80"></el-table-column>
          <el-table-column
            v-for="item in monthColumns"
            :key="item.id"
            :label="item.starName"
            :prop="'monthTargetNum' + item.saleStar"
            min-width="150"
          ></el-table-column>
          <el-table-column label="目标数量" min-width="150">
            <template #default="{ row }">
              <div v-if="!row.hasExpired" class="btn">
                <el-link type="primary" style="margin-right: 20px;" @click="showOrHideEditGoalModalHandle('month', row)">编辑</el-link>
                <el-link type="danger" @click="deleteHandle('month', row)">删除</el-link>
              </div>
              <span v-else>(已过去的日期不允许操作)</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 目标详情弹窗 -->
    <CustomModal
      v-model="showEditGoalModal"
      title="编辑目标"
      width="800px"
      @submitHandle="submitHandle()"
      @cancelHandle="showOrHideEditGoalModalHandle()"
    >
      <div class="goal-detail">
        <div class="name">姓名：{{ employeeName || '' }}</div>
      </div>
      <el-table :data="editGoalModalTableData" border stripe>
        <el-table-column
          :prop="editGoalModalType + 'Name'"
          :label="editGoalModalType === 'year' ? '年份' : editGoalModalType === 'quarter' ? '季度' : '月份'"
          min-width="100"
        ></el-table-column>
        <el-table-column
          v-for="item in editGoalModalColumns"
          :key="item.id"
          :label="item.starName"
          :prop="editGoalModalType + 'TargetNum' + item.saleStar"
          min-width="150"
        >
          <template #default="{ row }">
            <el-input
              style="width: 100%"
              v-model="row[editGoalModalType + 'TargetNum' + item.saleStar]"
              placeholder="请输入"
              clearable
            >
              <template #append>个</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from '@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'
import utils from '@/views/DoctorVisitLTC/utils/index'
import request from '@/utils/request'

export default{
  data(){
    return {
      yearColumns: [],
      yearTableData: [],
      quarterColumns: [],
      quarterTableData: [],
      monthColumns: [],
      monthTableData: [],
      
      editGoalModalType: '',
      showEditGoalModal: false,
      editGoalModalColumns: [],
      editGoalModalTableData: []
    }
  },
  methods: {
    async getGoalDetail() {
      const params = {
        userTargetConfigId: this.goalId
      }
      try {
        const res = await request.get('/cluepool/pc/admin/target/detail', params, '')
        if(res.code === 200) {
          const starTextInfo = {
            3: '三星',
            4: '四星',
            5: '五星'
          }
          const numTextInfo = {
            1: '一',
            2: '二',
            3: '三',
            4: '四'
          }
          const goalList = (res.data.targetConfigItemList || []).filter(item => item.targetNumber > 0).map(item => ({
            ...item,
            year: res.data.year,
            yearName: res.data.year + '年',
            quarterName: `第${numTextInfo[item.quarter]}季度`,
            monthName: `${item.month}月`,
            ['yearTargetNum' + item.saleStar]: item.period === 1 ? item.targetNumber : '',
            ['quarterTargetNum' + item.saleStar]: item.period === 2 ? item.targetNumber : '',
            ['monthTargetNum' + item.saleStar]: item.period === 3 ? item.targetNumber : '',
            ['starName']: starTextInfo[item.saleStar],
            ['userTargetConfigItemId' + item.saleStar]: item.userTargetConfigItemId,
            hasExpired: +new Date() > item.endTime,
          }))
          const yearTableData = goalList.filter(item => item.period === 1)
          const quarterTableData = goalList.filter(item => item.period === 2)
          const monthTableData = goalList.filter(item => item.period === 3)
          const resultYearTableData = []
          const resultQuarterTableData = []
          const resultMonthTableData = []
          yearTableData.forEach(el => {
            const index = yearTableData.findIndex(item => item.year === el.year)
            if (index === -1) {
              resultYearTableData.push(el)
            } else {
              resultYearTableData[index] = {
                ...resultYearTableData[index],
                ...el
              }
            }
          })
          quarterTableData.forEach(el => {
            const index = quarterTableData.findIndex(item => item.quarter === el.quarter)
            if (index === -1) {
              resultQuarterTableData.push(el)
            } else {
              resultQuarterTableData[index] = {
                ...resultQuarterTableData[index],
                ...el
              }
            }
          })
          monthTableData.forEach(el => {
            const index = monthTableData.findIndex(item => item.month === el.month)
            if (index === -1) {
              resultMonthTableData.push(el)
            } else {
              resultMonthTableData[index] = {
                ...resultMonthTableData[index],
                ...el
              }
            }
          })
          this.yearTableData = resultYearTableData
          this.quarterTableData = resultQuarterTableData
          this.monthTableData = resultMonthTableData
          this.yearColumns = yearTableData.filter((item, index, arr) => index === arr.findIndex(ite => ite.saleStar === item.saleStar))
          this.quarterColumns = quarterTableData.filter((item, index, arr) => index === arr.findIndex(ite => ite.saleStar === item.saleStar))
          this.monthColumns = monthTableData.filter((item, index, arr) => index === arr.findIndex(ite => ite.saleStar === item.saleStar))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取目标详情数据请求失败', error)
      }
    },

    // 获取编辑目标接口参数
    getEditParams(type, itemInfo, isDelete = false) {
      const params = []
      const itemInfoKeyList = Object.keys(itemInfo).filter(item => item.startsWith('userTargetConfigItemId') && item !== 'userTargetConfigItemId')
      if (type === 'year') {
        itemInfoKeyList.forEach(el => {
          params.push({
            userTargetConfigId: itemInfo.userTargetConfigId,
            userTargetConfigItemId: itemInfo[el],
            targetNumber: isDelete ? 0 : itemInfo[('yearTargetNum' + el.replace('userTargetConfigItemId', ''))]
          })
        })
      }
      if (type === 'quarter') {
        itemInfoKeyList.forEach(el => {
          params.push({
            userTargetConfigId: itemInfo.userTargetConfigId,
            userTargetConfigItemId: itemInfo[el],
            targetNumber: isDelete ? 0 : itemInfo[('quarterTargetNum' + el.replace('userTargetConfigItemId', ''))]
          })
        })
      }
      if (type === 'month') {
        itemInfoKeyList.forEach(el => {
          params.push({
            userTargetConfigId: itemInfo.userTargetConfigId,
            userTargetConfigItemId: itemInfo[el],
            targetNumber: isDelete ? 0 : itemInfo[('monthTargetNum' + el.replace('userTargetConfigItemId', ''))]
          })
        })
      }

      return params
    },

    // 删除目标（调用编辑接口，设置目标为0）
    async deleteHandle(type, itemInfo) {
      const textInfo = {
        year: '年度目标',
        quarter: '季度目标',
        month: '月目标'
      }
      const validConfirm = await utils.messageBoxConfirm({
        title: '提示',
        message: '确认删除当前' + textInfo[type] + '？'
      })
      if (!validConfirm) return

      const params = this.getEditParams(type, itemInfo, true)
      if (params.length === 0) return
      try {
        const res = await request.post('/cluepool/pc/admin/target/batchEditTargetItem', params, '')
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getGoalDetail()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('删除调用编辑接口数据请求失败', error)
      }
    },

    // 显示编辑目标弹窗
    showOrHideEditGoalModalHandle(type, itemInfo) {
      this.editGoalModalType = type
      if (type === 'year') {
        this.editGoalModalColumns = this.yearColumns
      } else if (type === 'quarter') {
        this.editGoalModalColumns = this.quarterColumns
      } else if (type === 'month') {
        this.editGoalModalColumns = this.monthColumns
      } else {
        this.editGoalModalColumns = []
      }
      this.editGoalModalTableData = [{
        ...itemInfo
      }]
      this.showEditGoalModal = !this.showEditGoalModal
    },

    // 提交编辑目标数据
    async submitHandle() {
      const params = this.getEditParams(this.editGoalModalType, this.editGoalModalTableData[0], false)
      if (params.length === 0) return
      try {
        const res = await request.post('/cluepool/pc/admin/target/batchEditTargetItem', params, '')
        if (res.code === 200) {
          this.$message.success('操作成功')
          this.getGoalDetail()
          this.showOrHideEditGoalModalHandle()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('提交编辑目标数据请求失败', error)
      }
    }
  },
  props: {
    goalId: {
      type: [String, Number],
      default: ''
    },
    employeeName: {
      type: String,
      default: ''
    }
  },
  components: {
    CustomModal
  },
  watch: {
    goalId: {
      handler(newVal) {
        if (newVal) {
          this.getGoalDetail()
        }
      },
      immediate: true
    }
  },
}
</script>

<style scoped lang="less">
.goal-detail {
  max-height: calc(100vh - 260px);
  overflow-y: auto;

  .name, .item-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .item {
    margin-top: 20px;
  }
}
</style>
